import React, { useEffect, useState } from "react";
import "./DematSelection.scss";
import DematSelectionForm from "./DematSelectionForm";
import { decryptJwtToken } from "../Services/dashboard/encryptionNew";
import GlobalStore from "../store/globalStore";
import { ITokenObj } from "../types/genericTypes";
import { DropOffLogAPI } from "../Services/dashboard/docVerificationAPIServices";

const DematSelection = (props: any) => {
  const dropOffObj = () => {
    let userId = 0;
    //  console.log("searchByPan token", decryptJwtToken(GlobalStore?.token));
    const tokenObj: string = decryptJwtToken(GlobalStore?.token);
    if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
      let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
      userId = parseInt(tokenMainObj?.UserId?.toString());
    }
    const stageInfoObj = {
      applicationid: GlobalStore?.applicationID,
      accountCagtegory: GlobalStore?.stageStatus?.accountcategory
        ? GlobalStore?.stageStatus?.accountcategory
        : GlobalStore?.accountcategory,
      stageOrderId: 16,
      userId: userId?.toString(),
      rmAssisted: GlobalStore?.stageStatus?.rmassisted,
    };
    DropOffLogAPI(() => {}, stageInfoObj);
  };
  React.useEffect(() => {
    dropOffObj();
  }, []);
  return (
    <>
      <div className="dematMain">
        <div className="dematHeading">Demat Account</div>
        <div className="dematSubHeading">
          Provide your demat account details.
        </div>
        <DematSelectionForm />
      </div>
    </>
  );
};

export default DematSelection;
